module.exports = __webpack_public_path__ + "img/anticlockwise-rotation.872b5749.svg";